import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsDownloadAppraisalsAndReceiptsForJob extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      showJobScheduler: false,
      apiUrlToMarkJobUnplanned:"/api/v1/portal/jobs/mark-job-unplanned/",
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  downloadAppraisalsAndReceiptsForJob() {
    console.log('receipts download here');
    return;
  }
  markJobToGoUnderUnplannedList(e){
    return fetch(
      this.state.apiUrlToMarkJobUnplanned+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
       alert('Job moved to unplanned list..');
      }
    ).catch((error)=>{
        alert('Something went wrong!');
    })
  }

  render() {
    return(
      <div>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            this.downloadAppraisalsAndReceiptsForJob();
          }}
          className="btn btn-lg btn-success">
          <i className="fa fa-download">
          </i> Download Appraisals and Receipts For Job
        </a>
        <br/><br/><br/>
        {(this.state.data.status == "completed" && this.state.data.unit_hired_term == "short") ? 
          <button
            className="btn btn-lg btn-dark"
            onClick={(e) => {
              this.markJobToGoUnderUnplannedList(e)
            }}>
            Move back to driver for collection
            </button> 
          : ""}
      </div>
    )
  }
}